import * as ActionTypes from '../ActionTypes';

const initialState = {
    letterHeadData: [],
    isLoading: false,
    company_logo : "",
    logoLoading: false
};

const LetterHeadReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.LETTER_HEAD_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                letterHeadData: "",
            };
        case ActionTypes.LETTER_HEAD_GET_SUCCESS:
            return {
                ...state,
                success_message: action.payload.message,
                error: action.payload.has_error,
                isLoading: false,
                letterHeadData: action.payload?.data?.data
            };
        case ActionTypes.LETTER_HEAD_GET_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        case ActionTypes.LETTER_HEAD_UPDATE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
                addSuccess: false,
            };
        case ActionTypes.LETTER_HEAD_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                addSuccess: true,
                successMessage: action.payload?.message,
                letterHeadData: action.payload?.data?.data,
            };
        case ActionTypes.LETTER_HEAD_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                addSuccess: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message,
              
            };
        case ActionTypes.COMPANY_LOGO_GET_REQUEST:
        case ActionTypes.COMPANY_LOGO_UPDATE_REQUEST:
            return {
                ...state,
                logoLoading: true,
            };
        case ActionTypes.COMPANY_LOGO_GET_SUCCESS:
        case ActionTypes.COMPANY_LOGO_UPDATE_SUCCESS:
            return {
                ...state,
                success_message: action.payload.message,
                error: action.payload.has_error,
                logoLoading: false,
                company_logo: action.payload?.data?.data?.[0]?.companylogo || ""
            };
        case ActionTypes.COMPANY_LOGO_GET_ERROR:
        case ActionTypes.COMPANY_LOGO_UPDATE_ERROR:
            return {
                ...state,
                logoLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        default:
            return state;
    }
}

export default LetterHeadReducer;